export function onlyDigits(value: string): string {
  return value.replace(/\D/g, '');
}

export function buildTelHref(phone: string): string {
  const digits = onlyDigits(phone);
  return digits ? `tel:${digits}` : '';
}

export function buildWhatsAppHref(phone: string): string {
  const digits = onlyDigits(phone);

  if (!digits) {
    return '';
  }

  const normalized = digits.startsWith('55') ? digits : `55${digits}`;

  return `https://api.whatsapp.com/send?phone=${normalized}`;
}

export function buildMailtoHref(email: string): string {
  const trimmed = email.trim();
  return trimmed ? `mailto:${trimmed}` : '';
}
